export const bushi = ['16 16', `
  <g xmlns="http://www.w3.org/2000/svg">
    <title>bushi</title>
    <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">施</text>
   </g>
 `]

export const chijie = ['16 16', `
 <g xmlns="http://www.w3.org/2000/svg">
   <title>bushi</title>
   <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">戒</text>
  </g>
`]

export const chanxiu = ['16 16', `
  <g xmlns="http://www.w3.org/2000/svg">
    <title>bushi</title>
    <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">修</text>
   </g>
 `]

export const fuwu = ['16 16', `
 <g xmlns="http://www.w3.org/2000/svg">
   <title>bushi</title>
   <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">服</text>
  </g>
`]

export const gongjing = ['16 16', `
  <g xmlns="http://www.w3.org/2000/svg">
    <title>bushi</title>
    <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">恭</text>
   </g>
 `]

 export const huixiang = ['16 16', `
   <g xmlns="http://www.w3.org/2000/svg">
     <title>bushi</title>
     <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">回</text>
    </g>
  `]

 export const suixi = ['16 16', `
  <g xmlns="http://www.w3.org/2000/svg">
    <title>bushi</title>
    <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">喜</text>
   </g>
 `]

 export const tingwen = ['16 16', `
   <g xmlns="http://www.w3.org/2000/svg">
     <title>bushi</title>
     <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">听</text>
    </g>
  `]

 export const hongyang = ['16 16', `
  <g xmlns="http://www.w3.org/2000/svg">
    <title>bushi</title>
    <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">弘</text>
   </g>
 `]

 export const zhengjian = ['16 16', `
   <g xmlns="http://www.w3.org/2000/svg">
     <title>bushi</title>
     <text xmlns="http://www.w3.org/2000/svg" xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="15" id="svg_1" y="13.5" x="0" stroke-width="0" stroke="#000" fill="#000000">见</text>
    </g>
  `]
